import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-vertx',
	templateUrl:'./VertxPluginPage.html',
	styles: [],
	styleUrls:['./VertxPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		MarkdownComponent,
],
	standalone:true
})
export class VertxPluginPage
{
	mdContent_124 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp</groupId>
  <artifactId>jwebmp-vertx</artifactId>
</dependency>
\`\`\``;
	mdContent_125 = `\`\`\`kotlin
implementation("com.jwebmp:jwebmp-vertx:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_126 = `\`\`\`java
@PageConfiguration(url = "/")
public class HomePage extends Page<HomePage> {
    public HomePage() {
        getBody().add(
            new H1<>().setText("Hello from JWebMP")
        );
    }
}
\`\`\``;
	mdContent_127 = `\`\`\`java
IGuiceContext.instance().inject();
// Routes auto-registered:
// GET /       -> Page rendering
// POST /jwajax -> AJAX events
// GET /jwdata  -> Data components
// GET /jwcss   -> Page CSS
\`\`\``;
	mdContent_128 = `\`\`\`java
@PageConfiguration(url = "/")
public class HomePage extends Page<HomePage> {
    public HomePage() {
        getBody().add(
            new H1<>().setText("Hello from JWebMP")
        );
    }
}

// Start the server
IGuiceContext.instance().inject();
// Routes auto-registered:
// GET /      → HomePage
// POST /jwajax → AJAX events
// GET /jwdata  → data components
// GET /jwcss   → page CSS
\`\`\``;
}
